import * as React from 'react';
import appReducer from './appReducer.js';
import { AppContext } from './appContext.js';

function AppProvider({children}) {

  const [state, dispatch] = React.useReducer(appReducer, { 
    user: {
      location: {},
      notifactions: {},
      partnerInfo: {},
    },
    userTypes: [],
    partnerTypes: [], 
    userAccount: {
      isAdmin: false,
      isPatient: false,
      isPartner: false,
      isStaff: false,
      isRoot: false,
      isPatientOrPartner: false,
      isPatientOrAdmin: false,
      isPartnerOrAdmin: false,
    },
    isAuthenticated: false, 
    isLoading: false,
    userNotifications: []
  }, () => {
    return localStorage.getItem('jwtToken') ? { 
      user: {
        location: {},
        notifactions: {},
        partnerInfo: {},
        user_type: 'temp'
      }, 
      userTypes: [],
      partnerTypes: [], 
      userAccount: {
        isAdmin: false,
        isPatient: false,
        isPartner: false,
        isStaff: false,
        isRoot: false,
        isPatientOrPartner: false,
        isPatientOrAdmin: false,
        isPartnerOrAdmin: false,
      },
      isAuthenticated: true, 
      isLoading: true, 
      userNotifications: []
     } : { 
      user: {
        location: {},
        notifactions: {},
      partnerInfo: {},
      }, 
      userTypes: [],
      partnerTypes: [], 
      userAccount: {
        isAdmin: false,
        isPatient: false,
        isPartner: false,
        isStaff: false,
        isRoot: false,
        isPatientOrPartner: false,
        isPatientOrAdmin: false,
        isPartnerOrAdmin: false,
      },
      isAuthenticated: false, 
      isLoading: false,
      userNotifications: []
    }
  });
  
  /* // NOTE: you *might* need to memoize this value
  // Learn more in http://kcd.im/optimize-context
  const value = React.useMemo(() => [state, dispatch], [state]) */

  //No memoization needed
  const value = [state, dispatch];

  return (
    <AppContext.Provider value={ value }>
      { children }
    </AppContext.Provider>
  )
}

export default AppProvider;